import React from 'react';
import Helpers from './Helpers.js'
// import Button from './Button.js';

import './TotalsView.css';
import TotalInfo from './TotalInfo.js';
import Bars from './Bars.js'
import Legend from './Legend.js'
import Notes from './Notes.js'


class TotalsView extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
		   barMode: "electors",
		   test: 10
		}
		this.setBarMode = this.setBarMode.bind(this)

	}

	setBarMode(index) {
		this.setState({
			barMode: index
		})
	}

	getPercent(total,part) {
		let output = Math.floor(part/total*100*100)/100;
		return (output)
	}


	render() {
		return(
			<div className = 'TotalsView'>
				<div className='TotalsBars'>
					<div className='totalBarBox'>
						<TotalInfo
							totals = {this.props.totals}
							parties = {this.props.parties}
							candidates = {this.props.candidates}
							infoKey = "Democratic Party"
							label = "Demokraten"
							styleName = "democrats"
						>
						</TotalInfo>
						<TotalInfo
							totals = {this.props.totals}
							parties = {this.props.parties}
							candidates = {this.props.candidates}
							infoKey = "Republican Party"
							label = "Republikaner"
							styleName = "republicans"
						>
						</TotalInfo>
					
					
						{
						// POLLS
						this.props.show==="polls" &&
										
						<div className='bothTotalBars'>
							<div className='barTitle barTitle-above'>Elektoren</div>
							<Bars 
								totals = 		{this.props.totals}
								barMode = 		"polls_electors"
								parties = 		{this.props.parties}
								candidates = 	{this.props.candidates}
								polls = 		{this.props.polls}
							></Bars>
							<div className='mark-270'>
							270
							</div>
							{/* <Bars 
								totals = 		{this.props.totals}
								barMode = 		"polls_votes"
								parties = 		{this.props.parties}
								candidates = 	{this.props.candidates}
								polls = 		{this.props.polls}

							></Bars>
							<div className='barTitle barTitle-below'>Stimmen (Polls)</div> */}
						</div>
						}
						{
						this.props.show==="polls" &&					
						<Legend
							show = "polls"
							polls = {this.props.polls}
						></Legend>
						// POLLS END
						}
					
						{
						this.props.show==="results" && this.props.parties.a.length>0 &&
										
						<div className='bothTotalBars'>
							<div className='barTitle barTitle-above'>Elektoren</div>
							<Bars 
								totals = 		{this.props.totals}
								barMode = 		"electors"
								parties = 		{this.props.parties}
								candidates = 	{this.props.candidates}
								polls = 		{this.props.polls}
							></Bars>
							<div className='mark-270'>
							270
							</div>
							<Bars 
								totals = 		{this.props.totals}
								barMode = 		"votes"
								parties = 		{this.props.parties}
								candidates = 	{this.props.candidates}
								polls = 		{this.props.polls}
							></Bars>
							<div className='barTitle barTitle-below'>Stimmen</div>
						</div>	
						}
						{
						this.props.show==="results" && this.props.parties.a.length>0 &&					
						<Legend
							show = "result"
							polls = {this.props.polls}
						></Legend>
						}
						{
						this.props.parties.a.length<=0 &&					
						<div>
							Noch keine Resultate.
						</div>
						}
					</div>
				</div>
				{
				this.props.mode==="full" &&

				<div className='TotalsBox'>
					<div className='totalsItem'>
						<div className='totalsLabel'>
							Elektoren zum Sieg: 
						</div>						
						<div className='totalsValue'>
							{this.props.totals.electors_to_win}
						</div>
					</div>
					<div className='totalsItem'>
						<div className='totalsLabel'>
							Unzugeteilte Elektoren: 
						</div>						
						<div className='totalsValue'>
							{this.props.totals.all_electors-this.props.totals.attributed.electors}
						</div>
					</div>							
					<div className='totalsItem'>
						<div className='totalsLabel'>
							Zugeteilte Elektoren: 
						</div>						
						<div className='totalsValue'>
							{this.props.totals.attributed.electors} / {this.props.totals.all_electors}
						</div>
					</div>

					{
					this.props.debug===true &&
						<span>
							<div className='totalsItem'>
								<div className='totalsLabel'>
									Favoriten Elektoren: 
								</div>						
								<div className='totalsValue'>
									{Helpers.tsnds(this.props.totals.attributed.favorites.electors)}
								</div>
							</div>
									
							<div className='totalsItem'>
								<div className='totalsLabel'>
									Andere Elektoren: 
								</div>						
								<div className='totalsValue'>
									{Helpers.tsnds(this.props.totals.attributed.others.electors)}
								</div>
							</div>
						</span>
					}


					<div className='totalsItem'>
						<div className='totalsLabel'>
							Ausgezählte Stimmen: 
						</div>						
						<div className='totalsValue'>
							{Helpers.tsnds(this.props.totals.votes)} 
							{
								this.props.year*1===2020 &&
								<span className='unbold'>+</span>
							}
						</div>
					</div>

					{
					this.props.debug===true &&
						<span>

							<div className='totalsItem'>
								<div className='totalsLabel'>
									Favoriten Stimmen: 
								</div>						
								<div className='totalsValue'>
									{Helpers.tsnds(this.props.totals.attributed.favorites.votes)}
								</div>
							</div>
							<div className='totalsItem'>
								<div className='totalsLabel'>
									Andere Stimmen: 
								</div>						
								<div className='totalsValue'>
									{Helpers.tsnds(this.props.totals.attributed.others.votes)}
								</div>
							</div>	

							<div className='totalsItem'>
								<div className='totalsLabel'>
									«Ausgezählte» Prozent: 
								</div>						
								<div className='totalsValue'>
									{Helpers.tsnds(this.props.totals.attributed.percent)}%
								</div>
							</div>										
							<div className='totalsItem'>
								<div className='totalsLabel'>
									Favoriten Prozent: 
								</div>						
								<div className='totalsValue'>
									{Helpers.tsnds(this.props.totals.attributed.favorites.percent)}%
								</div>
							</div>
							<div className='totalsItem'>
								<div className='totalsLabel'>
									Andere Prozent: 
								</div>						
								<div className='totalsValue'>
									{Helpers.tsnds(this.props.totals.attributed.others.percent)}%
								</div>
							</div>	
						</span> }



					{/* <div className='totalsItem'>
						<div className='totalsLabel'>
							Kandidaten: 
						</div>						
						<div className='totalsValue'>
							{this.props.totals.candidates}
						</div>
					</div>
					<div className='totalsItem'>
						<div className='totalsLabel'>
							Staaten: 
						</div>						
						<div className='totalsValue'>
							{this.props.totals.attributed.states} / {this.props.totals.states} 
						</div>
					</div> */}

				</div>
				}
				<Notes
					notes = {this.props.notes}
				></Notes>
			</div>
			
		)
	}
}

export default TotalsView
